import { americanTypeCf, hongKongTypeCf, indonesianTypeCf, malaysianTypeCf } from './calcFunctions';
export const WHITE_LIST_PROJECTS = [
    'zenitbet',
    'mobile_com',
    'desktop',
    'mobile_new'
];
export const COEF_TYPES = {
    1: 'EUROPEAN',
    2: 'AMERICAN',
    3: 'HONGKONG',
    4: 'INDONESIAN',
    5: 'MALASYIAN',
};
const COEF_CALCULATE = {
    'AMERICAN': americanTypeCf,
    'HONGKONG': hongKongTypeCf,
    'INDONESIAN': indonesianTypeCf,
    'MALASYIAN': malaysianTypeCf
};
/**
 * Функция приводит к разным типам входящий коэффициент
   @param {cf}: кэф, европейского типа.
   @param {type}: id типа кэфа, согласно COEF_TYPES
   @param {appName}: имя проекта
   @param {notConvertCf}: флаг игнорирование преобразования кэфов
 **/
export const insertCoefByType = (cf, type, appName, notConvertCf = false) => {
    if (cf === undefined) {
        return ' ';
    }
    if (!WHITE_LIST_PROJECTS.includes(appName) || notConvertCf) {
        return numberFormatter(cf, 2, ',', ' ');
    }
    if (type === 1)
        return String(numberFormatter(cf, 2, ',', ' '));
    if (type === 2)
        return String(COEF_CALCULATE[COEF_TYPES[type]](cf));
    return String(numberFormatter(COEF_CALCULATE[COEF_TYPES[type]](cf), 2, ',', ' '));
};
const numberFormatter = (number, decimals, dec_point, thousands_sep) => {
    // * example 1: number_format(1234.56);
    // * returns 1: '1,235'
    // * example 2: number_format(1234.56, 2, ',', ' ');
    // * returns 2: '1 234,56'
    // * example 3: number_format(1234.5678, 2, '.', '');
    // * returns 3: '1234.57'
    const n = !isFinite(+number) ? 0 : +number;
    const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
    const sep = typeof thousands_sep === 'undefined' ? '' : thousands_sep;
    const dec = typeof dec_point === 'undefined' ? '.' : dec_point;
    //let s = '';
    const toFixedFix = function (n, prec) {
        const k = Math.pow(10, prec);
        return `${Math.round(n * k) / k}`;
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    const s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
};
export default insertCoefByType;



// WEBPACK FOOTER //
// ./src/web-frontend-core/helpers/calcCoefType/insertCoefByType.js